import React from "react";
import Home from "./pages/Home";

import "./App.scss";

const App = () => {
  return (
    <div className="App">
      <Home />
    </div>
  );
};

export default App;
